export default "__VITE_ASSET___bl5JGwc__"